import { reduce, isEmpty, has } from 'lodash'

class URLQueryString {
    constructor(queryPath) {
        this.queryPath = queryPath
        this._values()
    }
    _values() {
        if(isEmpty(this.queryPath)) return {}
        this.queryPath = reduce(this.queryPath.slice(1).split('&'), (result, val) => {
            const [key, value] = val.split('=')
            if(isEmpty(key) || isEmpty(value)) return {}
            return { ...result, [key]: value }
        }, {})
    }
    has(param) {
        return has(this.queryPath, param)
    }
}

export default URLQueryString
